import { makeAutoObservable, runInAction } from 'mobx';
import { FORM_ERROR } from 'final-form';
import isEmpty from 'lodash/isEmpty';
import { createToast, TOAST_TYPES } from '@components/Toast';
import {
  API,
  APIRoutes,
  setAuthenticationHeaders,
  cacheAuthenticationHeaders,
} from '@api';
import { clear, getItem, KEYS } from '@app/cache';
import { routerStore } from '@stores';
import routes from '@routes';

export class AuthStore {
  isLoading = false;

  authenticationToken = '';

  isAuthenticated = false;

  initialized = false;

  customer = {};

  loadingCustomers = false;

  userUID = null;

  constructor() {
    makeAutoObservable(this);
  }

  initialize = () => {
    this.initialized = true;
  };

  fetchCustomer = async () => {
    runInAction(() => {
      this.loadingCustomers = true;
    });
    try {
      if (isEmpty(this.customer)) {
        const {
          data: { customer },
        } = await API.get(APIRoutes.CUSTOMER);
        runInAction(() => {
          this.customer = customer;
        });
      }
    } catch (error) {
      console.warn(error); // eslint-disable-line
    } finally {
      runInAction(() => {
        this.loadingCustomers = false;
      });
    }
  };

  signInWithSession = token => {
    setAuthenticationHeaders();
    this.isAuthenticated = true;
    this.authenticationToken = token;
    this.initialized = true;
    this.userUID = getItem(KEYS.UID);
  };

  signIn = async ({ email, password }, setSubmiting, setErrors, resetForm) => {
    this.isLoading = true;
    try {
      const {
        data: { customer },
        headers,
      } = await API.post(APIRoutes.SIGN_IN, {
        email,
        password,
      });
      setSubmiting(false);

      if (customer.delivery_partner) {
        cacheAuthenticationHeaders(headers);
        setAuthenticationHeaders();
        runInAction(() => {
          this.authenticationToken = headers['access-token'];
          this.userUID = headers.uid;
          this.customer = customer;
          this.isAuthenticated = true;
          this.initialized = true;
        });
        routerStore.push(routes.labels);
      } else {
        createToast("You don't have permission to access.", TOAST_TYPES.ERROR);
        resetForm();
      }
    } catch (e) {
      setErrors({ email: ' ', password: ' ' });
      setSubmiting(false);
      createToast(e.errors.general, TOAST_TYPES.ERROR);
      return { [FORM_ERROR]: 'Invalid email or password!' };
    } finally {
      this.isLoading = false;
    }

    return null;
  };

  logout = async () => {
    this.isAuthenticated = false;
    clear();
    routerStore.push(routes.auth.signIn);
  };
}

export default new AuthStore();
